// main components
import React from 'react'
import { useTranslation } from 'react-i18next'

// mui components
import {
  Typography,
  Card,
  CardContent,
  CardActions,
  Link,
  Box
} from '@mui/material'
// services
import { supportCardStyles } from '../../styles/classes/CompanySettingsClasses'
import { envVariables } from '../../lib/Constants'

const pjson = require('../../../package.json')

export const SupportCard = props => {
  const { classes } = supportCardStyles()
  const { t } = useTranslation()

  return (
    <Card className={classes.card} data-testid={'support_card'}>
      <CardActions disableSpacing classes={{ root: classes.actions }}>
        <Typography classes={{ root: classes.title }}>
          {t('company_settings.support_card.title')}
        </Typography>
      </CardActions>
      <CardContent classes={{ root: classes.content }}>
        {/* This is going to be used on the future, do not delete. */}
        {/* <Box margin="0px 0px 25px 0px" padding={0}>
          <Link
            data-testid="knowledge_button"
            onClick={() =>
              window.open(
                process.env.REACT_APP_FTC_KNOWLEDGE_BASE_SUPPORT,
                '_blank',
                'noopener,noreferrer'
              )
            }
            classes={{ root: classes.link }}
          >
            {t('company_settings.support_card.knowledge')}
          </Link>
        </Box> */}
        <Box margin="0px 0px 25px 0px" padding={0}>
          <Typography className={classes.text}>
            <Link
              data-testid="privacy_policy_button"
              to={{ pathname: envVariables.REACT_APP_FTC_PRIVACY_POLICY_URL }}
              onClick={() => window.open(envVariables.REACT_APP_FTC_PRIVACY_POLICY_URL)}
              rel="noopener noreferrer"
              target="_blank"
              variant={'body2'}
              classes={{ root: classes.link }}
            >
              {t('company_settings.support_card.privacy_policy')}
            </Link>
            {' & '}
            <Link
              to={{ pathname: envVariables.REACT_APP_FTC_TERMS_OF_SERVICE_URL }}
              onClick={() => window.open(envVariables.REACT_APP_FTC_TERMS_OF_SERVICE_URL)}
              rel="noopener noreferrer"
              target="_blank"
              variant={'body2'}
              classes={{ root: classes.link }}
            >
              {t('company_settings.support_card.conditions')}
            </Link>
          </Typography>
        </Box>
        <Typography classes={{ root: classes.versionLabel }}>
          {t('company_settings.support_card.version')} {pjson.version}
        </Typography>
      </CardContent>
    </Card>
  )
}
